import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OptionChoice from 'components/application/OptionChoice';
import Options from 'components/application/Options';

import { useProjectCoshhContext } from 'components/contexts/ProjectCoshhContext';

export default function CoshhOptions({
  coshhDocument,
  onDeleteClick,
  onDownloadClick,
}) {
  const { coshhDocumentPolicy } = useProjectCoshhContext();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'projectCoshh.components.CoshhOptions',
  });

  return (
    <Options>
      <OptionChoice>
        <a
          className='tw-text-m tw-font-medium tw-tracking-auto tw-text-grey-700 hover:tw-text-grey-700'
          onClick={() => onDownloadClick({ coshhDocument })}
        >
          {i18nT('download')}
        </a>
      </OptionChoice>
      {coshhDocumentPolicy.canDestroy && (
        <OptionChoice warning={true}>
          <a
            className='tw-text-m tw-font-medium tw-tracking-auto tw-text-red-600 hover:tw-text-red-600'
            onClick={() => onDeleteClick({ coshhDocument })}
          >
            {i18nT('delete')}
          </a>
        </OptionChoice>
      )}
    </Options>
  );
}

CoshhOptions.propTypes = {
  coshhDocument: PropTypes.object.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
};
